import React from 'react';
import { Input } from 'antd';

import { getPointIcon } from '../extraFuncs';

import * as TourPoint from '../../../../constants/TourPoints';

import { publish } from '../../../../libs/core/PubSub';

import * as way from '../../../../libs/core/PubSubWays';

import TimeAndDistanceFullView from '../components/TimeAndDistanceFullView';

export const PointsEachPart = ({ points, edit, idSelectedPoint, part, tr }) => {
  const getPointId = (el) => {
    return el && el.attributes && el.attributes.rel
      ? el.attributes.rel.value
      : getPointId(el.parentNode);
  };

  const handlerPoint = (event) => {
    const customId = getPointId(event.target);
    const partId = part.id;
    switch (event.type) {
      case 'click':
        publish(way.DRIVE_MAP_STATIC_POINT_SELECTED, { customId });
        break;
      case 'mouseenter':
        publish(way.DRIVE_MAP_STATIC_POINT_MOUSEENTER, { customId, partId });
        break;
      case 'mouseleave':
        publish(way.DRIVE_MAP_STATIC_POINT_MOUSEENTER, { customId: 0 });
        break;
      default:
        console.warn(event.type);
    }
  };

  const getPartTitle = (point) => {
    return point.type === TourPoint.Type.START ? (
      <span
        className="list_item_title_multi_part"
        rel={point.id}
        key={`${point.id}span`}
        onClick={handlerPoint}
        onMouseEnter={handlerPoint}
        onMouseLeave={handlerPoint}
        aria-hidden
      >
        <span>
          {`${tr.Part} ${part.num} - `}
          <b>{part.title}</b>
        </span>
        <span style={{ fontSize: 11 }}>
          <TimeAndDistanceFullView
            distance={part.distance}
            duration={part.duration}
          />
        </span>
      </span>
    ) : null;
  };

  return points.map((point, i) => {
    if (
      point.type === TourPoint.Type.START ||
      point.type === TourPoint.Type.END ||
      point.isLastVia
    ) {
      if (point.isLastVia) {
        point.type = TourPoint.Type.END;
      }
      if (i === 0 && point.type === TourPoint.Type.END) {
        point.type = TourPoint.Type.START;
      }
      return (
        <React.Fragment key={`${point.id}frag`}>
          {getPartTitle(point)}
          {!point.lat && !point.lng && !point.address ? null : (
            <div
              style={{ width: '100%', float: 'right', height: 30 }}
              key={`${point.id}div`}
              rel={point.id}
              onClick={handlerPoint}
              onMouseEnter={handlerPoint}
              onMouseLeave={handlerPoint}
              aria-hidden
            >
              <PointListItem
                key={`${point.id}item`}
                point={point}
                isActive={point.id === idSelectedPoint}
                edit={edit}
              />
            </div>
          )}
        </React.Fragment>
      );
    }
    return null;
  });
};

export const PointListItem = ({ point, isActive, edit }) => {
  if (!point.lat && !point.lng && !point.address) {
    return null;
  }
  return (
    <Input
      // draggable={(edit)?true:false}
      className={!edit && isActive ? 'selecedInput' : ''}
      readOnly={!edit}
      defaultValue={point.address}
      key={point.id}
      rel={point.id}
      style={{ marginBottom: '6px' }}
      prefix={getPointIcon(point, isActive)}
      // className = 'list_item_multi_part'
      // suffix={(edit && pointId === point.id && isDragging === false)? InputSuffix(point) : null}
    />
  );
};
